import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [wsId, setWsId] = useState(localStorage.getItem("minit_ws"));
  const { setLang } = useApp();

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    // Google OAuth callback: AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const saveSession = async (data) => {
    localStorage.setItem("minit_token", data.token);
    const me = await refresh();
    if (me?.ui_language) setLang(me.ui_language);
    return me;
  };
  const login = async (email, password) => saveSession((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password, extra = {}) => saveSession((await api.post("/auth/register", { name, email, password, ...extra })).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("minit_token");
    setUser(false);
  };
  const selectWs = (id) => {
    localStorage.setItem("minit_ws", id);
    setWsId(id);
  };

  const workspaces = user?.workspaces || [];
  const workspace = workspaces.find((w) => w.id === wsId) || workspaces.find((w) => w.type === "team" && w.role !== "owner")
    || workspaces.find((w) => w.type === "personal") || workspaces[0];
  const canWrite = workspace && workspace.role !== "viewer";

  return (
    <AuthContext.Provider value={{ user, saveSession, login, register, logout, refresh, workspace, workspaces, selectWs, canWrite }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
